import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "smartsearch-serp__result-info-container q-container-xxl q-pt-1 q-d-flex"
}
const _hoisted_2 = { class: "q-lead q-container-fluid q-pb-1 q-my-1" }
const _hoisted_3 = {
  key: 0,
  class: "results__info-header q-fw-normal q-text-dark q-mb-0 q-text-left q-fs-5"
}
const _hoisted_4 = {
  key: 1,
  class: "q-fw-normal q-text-dark q-mb-0 q-text-center q-small"
}

import {storeToRefs} from "pinia";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {computed, inject} from "vue";
import {SmartSearchConfigInterface, SmartSearchTranslationsInterface} from "@/core/types";


// eslint-disable-next-line @typescript-eslint/no-non-null-assertion

export default /*@__PURE__*/_defineComponent({
  __name: 'ResultsInfoWrapper',
  setup(__props) {

const SmartSearchConfig = inject<SmartSearchConfigInterface>('SmartSearchConfig')!
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!
const {allowEmptyQuery} = SmartSearchConfig.value.serp.query


const serpStore = useSerpResultsStore();

const {query, total, getProductsCount, loading} = storeToRefs(serpStore)
const typeQueryState = computed(() => {
  return !loading.value && !allowEmptyQuery && !query.value
})



return (_ctx: any,_cache: any) => {
  return (_unref(query).length > 0 && _unref(getProductsCount) > 0 || _unref(getProductsCount) === 0 && _unref(query) || !_unref(allowEmptyQuery) && !_unref(query))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(query).length > 0 && _unref(getProductsCount) > 0)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_3, [
                _createTextVNode(_toDisplayString(_unref(SmartSearchTranslations).serp.resultHeader) + ":", 1),
                _cache[0] || (_cache[0] = _createElementVNode("br", { class: "q-d-block q-d-md-none" }, null, -1)),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("b", null, _toDisplayString(_unref(query)), 1),
                _createTextVNode(" (" + _toDisplayString(_unref(total)) + " " + _toDisplayString(_unref(SmartSearchTranslations).serp.results) + ") ", 1)
              ]))
            : _createCommentVNode("", true),
          (typeQueryState.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(SmartSearchTranslations).serp.typeQuery), 1))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})